export const INSURER_LIST = [
  { name: 'COLSEGUROS (AT1301)', code: 'AT1301' },
  { name: 'SEGUROS COLPATRIA (AT1306)', code: 'AT1306' },
  { name: 'ZLS ASEGURADORA DE COLOMBIA SA (AT1309)', code: 'AT1309' },
  { name: 'ROYAL & SUN ALLIANCE SEGUROS (AT1315)', code: 'AT1315' },
  { name: 'MUNDIAL DE SEGUROS (AT1317)', code: 'AT1317' },
  { name: 'COMPAÑÍA SURAMERICANA DE SEGUROS (AT1318)', code: 'AT1318' },
  { name: 'LA PREVISORA S.A. (AT1324)', code: 'AT1324' },
  { name: 'SEGUROS DEL ESTADO (AT1329)', code: 'AT1329' },
  { name: 'LIBERTY SEGUROS (AT1333)', code: 'AT1333' },
  { name: 'ASEGURADORA DE VIDA COLSEGUROS (AT1401)', code: 'AT1401' },
  { name: 'COMPAÑIA AGRICOLA DE SEGUROS (AT1405)', code: 'AT1405' },
  { name: 'SEGUROS DE VIDA COLPATRIA S.A. (AT1404)', code: 'AT1404' },
  { name: 'SEGUROS BOLIVAR S.A. (AT1327)', code: 'AT1327' },
  { name: 'SEGUROS DE VIDA ALFA S.A. (AT1417)', code: 'AT1417' },
  { name: 'LIBERTY SEGUROS DE VIDA S.A. (AT1418)', code: 'AT1418' },
  { name: 'SEGUROS DE VIDA DEL ESTADO S.A (AT1419)', code: 'AT1419' },
  { name: 'LA EQUIDAD SEGUROS DE VIDA (AT1429)', code: 'AT1429' },
  { name: 'BBVA SEGUROS DE VIDA SA (AT1426)', code: 'AT1426' },
  { name: 'COLMENA RIESGOS PROFESIONALES (AT1425)', code: 'AT1425' },
  { name: 'POSITIVA (AT1423)', code: 'AT1423' },
  { name: 'SEGUROS COMERCIALES BOLIVAR (AT1327)', code: 'AT1327' },
  { name: 'ASEGURADORA SOLIDARIA DE COLOMBIA (AT1502)', code: 'AT1502' },
  { name: 'MAPFRE (AT1326)', code: 'AT1326' },
  { name: 'ALLIANZ SEGUROS S.A (AT1301)', code: 'AT1301' },
  { name: 'EQUIDAD SEGUROS (AT1501)', code: 'AT1501' },
  { name: 'OTRA', code: 'OTRA' },
  { name: 'SIN POLIZA(SIN SOAT)', code: 'SIN SOAT' },
];